import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DocumentationPageV2 } from "../elements";
import { DesignElementSnapshotBase, pickLatestSnapshots } from "./base";

/**
 * Snapshot of a documentation page.
 *
 * Please note that existence of snapshot's references (including parent persistent id) is not guaranteed.
 */
export const DocumentationPageSnapshot = DesignElementSnapshotBase.extend({
  page: DocumentationPageV2,
  pageContentHash: z.string(),
  pageContentStorageKey: z.string(),
});

export type DocumentationPageSnapshot = z.infer<typeof DocumentationPageSnapshot>;

export type CreateDocumentationPageSnapshot = DbCreateInputOmit<DocumentationPageSnapshot>;
export type UpdateDocumentationPageSnapshot = OmitStrict<DbUpdate<DocumentationPageSnapshot>, "designSystemVersionId">;

//
// Util functions
//

export function pickLatestPageSnapshots(snapshots: DocumentationPageSnapshot[]): DocumentationPageSnapshot[] {
  return pickLatestSnapshots(snapshots, s => s.page.id);
}
